import { render, staticRenderFns } from "./ArchivePage.vue?vue&type=template&id=7432415c&"
import script from "./ArchivePage.vue?vue&type=script&lang=js&"
export * from "./ArchivePage.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports